import { PAGE_ACTION_DEPENDENCIES, SystemPermissions } from './permissions.js';

export type MarketplacePermissionEntry = {
  type: string;
  method: string;
  route: string;
};

/** Fulfillment/ETA ops — excluded from marketplace.admin catalog-bundle inheritance. */
export const MARKETPLACE_ORDER_OPS_ROUTES = new Set<string>([
  SystemPermissions.MARKETPLACE_UPDATE_ORDER_FULFILLMENT.route,
  SystemPermissions.MARKETPLACE_UPDATE_ORDER_ETA.route,
  SystemPermissions.MARKETPLACE_UPDATE_ORDER_SCRIPT_FULFILLMENT.route,
  SystemPermissions.MARKETPLACE_ADMIN_UPDATE_ORDER_SCRIPT_FULFILLMENT.route,
]);

/** Script-review GET routes must not count as sibling ACTION grants for other bundles. */
export const SCRIPT_REVIEW_READ_ONLY_ROUTES = new Set<string>([
  SystemPermissions.SCRIPT_REVIEW_GET.route,
  SystemPermissions.SCRIPT_REVIEW_GET_STATUS.route,
]);

export function marketplaceAdminBundleRoutesExcludingOrderOps(): Set<string> {
  return new Set(
    (PAGE_ACTION_DEPENDENCIES['marketplace.admin'] ?? []).filter(
      (route) => !MARKETPLACE_ORDER_OPS_ROUTES.has(route),
    ),
  );
}

/** True when the grants include marketplace order ops actions (ETA, fulfilment). */
export function hasMarketplaceOrderOpsAccess(
  permissions: ReadonlyArray<MarketplacePermissionEntry>,
): boolean {
  return permissions.some((p) => p.type === 'ACTION' && MARKETPLACE_ORDER_OPS_ROUTES.has(p.route));
}

/** True when the grants include marketplace.admin page or catalog/import actions. */
export function hasMarketplaceAdminBundleAccess(
  permissions: ReadonlyArray<MarketplacePermissionEntry>,
): boolean {
  const hasAdminPage = permissions.some(
    (p) => p.type === 'PAGE' && p.method === 'GET' && p.route === 'marketplace.admin',
  );
  if (hasAdminPage) return true;

  const bundleRoutes = marketplaceAdminBundleRoutesExcludingOrderOps();
  return permissions.some((p) => p.type === 'ACTION' && bundleRoutes.has(p.route));
}
